import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE } from '../lib/seo';

const abs = (u) => {
  if (!u) return SITE.ogImage;
  if (u.startsWith('http')) return u;
  return SITE.url + (u.startsWith('/') ? u : '/' + u);
};

const Seo = ({ title, description, path = '', image, type = 'website', jsonLd, noindex }) => {
  const url = SITE.url + path;
  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.defaultTitle;
  const desc = description || SITE.defaultDescription;
  const img = abs(image);
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow'} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
